import { addDays, isBefore, startOfDay } from "date-fns";

export type ContractStatus = {
  label: string;
  color: 'pending' | 'done' | 'cancelled';
};

/** A term ending within this window needs attention (notice periods are commonly up to 3 months). */
export const CONTRACT_DUE_SOON_DAYS = 90;

export function getContractStatus(endDate: Date | null, now: Date = new Date()): ContractStatus | null {
  if (!endDate) {
    return null;
  }

  const today = startOfDay(now);

  if (isBefore(endDate, today)) {
    return { label: 'Échu', color: 'cancelled' };
  }

  if (isBefore(endDate, addDays(today, CONTRACT_DUE_SOON_DAYS))) {
    return { label: 'Échéance proche', color: 'pending' };
  }

  return { label: 'En cours', color: 'done' };
}

export function getRenewalLabel(durationOfRenewal: number | null): string {
  if (!durationOfRenewal) {
    return 'Pas de renouvellement automatique';
  }

  return `Renouvellement automatique tous les ${durationOfRenewal > 1 ? `${durationOfRenewal} ` : ''}ans`;
}
